export default "__VITE_ASSET__DMRohNK2__"